import { Avatar, Box, IconButton, Paper, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import ContactSupportRoundedIcon from '@mui/icons-material/ContactSupportRounded';
import avatarImg from '../../assets/img/avatar-1.png';
import { useNavigate } from 'react-router';
import { useAppContext } from '../../contexts/AppContext';
import '../Customer/CustomerScreens.scss';

const settingsItems = [
  {
    icon: <AccountCircleRoundedIcon fontSize='small' />,
    label: 'Account Details',
    subtitle: 'Manage your profile and saved data',
    path: '/profile',
  },
  {
    icon: <NotificationsRoundedIcon fontSize='small' />,
    label: 'Notifications',
    subtitle: 'Check alerts and delivery updates',
    path: '/profile',
  },
  {
    icon: <EmailRoundedIcon fontSize='small' />,
    label: 'Email',
    subtitle: 'Update your sign-in and communication email',
    path: '/profile',
  },
  {
    icon: <LocationOnRoundedIcon fontSize='small' />,
    label: 'Location Services',
    subtitle: 'Set addresses and delivery preferences',
    path: '/profile',
  },
  {
    icon: <LogoutRoundedIcon fontSize='small' />,
    label: 'Log Out',
    subtitle: 'Sign out from your customer account',
    path: '/logout',
  },
];

const supportItems = [
  {
    icon: <ContactSupportRoundedIcon fontSize='small' />,
    label: 'Contact Us',
    subtitle: 'Need help with orders, payments, or refunds?',
    path: '/support',
  },
];

export default function Profile() {
  const navigate = useNavigate();
  const { user } = useAppContext();
  const profileName = user?.name || 'Alex Richards';
  const profileEmail = user?.email || 'alex.richards@example.com';

  const renderItem = (item) => (
    <Box
      key={item.label}
      className='customer-menuItem'
      component='button'
      onClick={() => navigate(item.path)}
      sx={{ border: 0, width: '100%', cursor: 'pointer' }}
    >
      <Box className='customer-menuLead'>
        <Box className='customer-menuIcon'>{item.icon}</Box>
        <Box sx={{ textAlign: 'left' }}>
          <Typography sx={{ fontWeight: 700 }}>{item.label}</Typography>
          <Typography className='customer-muted' sx={{ fontSize: '0.84rem' }}>
            {item.subtitle}
          </Typography>
        </Box>
      </Box>
      <ChevronRightRoundedIcon sx={{ color: '#7f8690' }} />
    </Box>
  );

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Account</Typography>
          <IconButton className='customer-iconButton' onClick={() => navigate('/support')}>
            <ContactSupportRoundedIcon />
          </IconButton>
        </Box>

        <Paper className='customer-card'>
          <Box className='customer-profileCard'>
            <Avatar src={avatarImg} className='customer-avatar' />
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography sx={{ fontWeight: 700 }}>{profileName}</Typography>
              <Typography className='customer-muted' noWrap>
                {profileEmail}
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Typography className='customer-sectionTitle'>Settings</Typography>
        <Box className='customer-menuList'>{settingsItems.map(renderItem)}</Box>

        <Typography className='customer-sectionTitle'>Support</Typography>
        <Box className='customer-menuList'>{supportItems.map(renderItem)}</Box>
      </Box>
    </Box>
  );
}
